import {ListItem} from '../ListItem'
import type {ChecksMetadata, RunMetadata} from '../../../../types/rules-types'
import {SHORT_SHA_LENGTH} from '../../../../helpers/constants'

export function StatusChecksList({metadata}: {metadata: RunMetadata}) {
  return (
    <ul>
      {(metadata as ChecksMetadata).checks.map(
        ({integrationName, integrationAvatarUrl, checkRunName, state, id, sha, description, warning}) => (
          <ListItem
            key={id}
            state={state}
            avatarUrl={integrationAvatarUrl}
            avatarLabel={integrationName}
            title={`${integrationName} / ${checkRunName}`}
            description={`${description} ${sha ? `• ${sha.toString().slice(0, SHORT_SHA_LENGTH)}` : ''}`}
            warning={warning}
          />
        ),
      )}
    </ul>
  )
}
